var exports = {
  "kL": "x93eb46d8--349f7d--container",
  "d$": "x93eb46d8--349f7d--arrows",
  "d": "x93eb46d8--349f7d--next_button",
  "US": "x93eb46d8--349f7d--months",
};

module.exports = exports;
